type ImageData = {
  image: string;
  heading: string;
  buttonCta: string;
  url: string;
}

type SearchDropDownProps = {
  servicesData: ImageData[];
}

function SearchBarServices({ servicesData }: SearchDropDownProps): JSX.Element {
  const desktopGridCols = servicesData.length >= 4
    ? 'lg:grid-cols-[repeat(4,minmax(0,396px))]'
    : 'lg:grid-cols-[repeat(3,minmax(0,396px))]'

  return (
    <div>
      {servicesData.length ? (
          <div className="mb-SM mt-XL flex w-full justify-center px-SM">
            <div className={`grid w-fit max-w-full grid-cols-[repeat(2,minmax(0,396px))] justify-center gap-3 md:gap-5 md:max-w-screen-2xl ${desktopGridCols}`}>
            {servicesData.map((imageData, i) => (
              <div
                key={i}
                  className="relative flex aspect-[4/5] w-full min-w-0 justify-center"
              >
                <img src={imageData.image} alt={imageData.heading} className='absolute w-full h-full object-cover'/> 
                <div className="font-bstSpyre text-white text-xl text-3xl sm:text-6xl text-center capitalize p-MD sm:p-XL absolute">
                  {imageData.heading}
                </div>
                <a href={imageData.url} 
                  className="absolute text-white font-calibre text-base-2 bottom-[15px] sm:bottom-[28.903px] min-w-[120px] sm:min-w-[150px] uppercase rounded-sm backdrop-blur-[25px] bg-opacity-50 bg-[#2E241D] text-center p-2 sm:p-3 sm:p-SM"
                >
                  {imageData.buttonCta}
                </a>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default SearchBarServices